export const transformPrimaryOfferings = (offerings) => {
  const transformedCurrentOfferings = {};

  Object.keys(offerings).forEach((key) => {
    if (Array.isArray(offerings[key])) {
      transformedCurrentOfferings[key] = offerings[key].map((item) => ({
        id: item?.id,
        name: item?.name,
        content: item?.content,
        coverTombstoneUrl: item?.startup_cover_url,
        logoUrl: item?.logo_url,
        regulationType: item?.investment_type_pretty,
        // this is previousRaiseTotal + fundsCommitted
        amountRaised: `${item?.funds_committed} USD`,
        maximumFundingAmount: item?.maximum_funding_amount,
        numberOfInvestors: item?.public_number_of_contributers,
        minimumInvestmentAmount: `${item?.minimum_investment_amount_pretty
          ?.replace('$', '')
          .replace(',', '')}`,
        companyName: item?.company_name,
        categories: item?.categories,
        lockedOnWaitlist: item?.locked_on_waitlist,
        endDate: item?.funding_end_date,
        days_left: item?.days_left,
        slug: item?.link,
        startengineCompany: {
          companyName: item?.startengine_company_name,
        },
        investorMatchedOffering: item?.investor_matched_offering,
        city: item?.city,
        state: item?.state,
        fundingEndDate: item?.funding_end_date,
        showPercentCompleted: item?.show_percent_completed,
        seBrokerDealer: item?.se_broker_dealer,
        seSellingBrokerDealer: item?.se_selling_broker_dealer,
        percentCompleted: item?.percent_completed,
        minimumInvestmentAmountPretty: item?.minimum_investment_amount_pretty,
        pricePerShare: item?.price_per_share,
        lastDayOfCampaign: item?.last_day_of_campaign,
        fundsCommitted: item?.funds_committed,
        publicFundsCommitted: item?.public_funds_committed,
        showAmtCommitted: item?.show_amt_committed,
        seBonusApplicable: item?.se_bonus_applicable,
        startengineCompanyName: item?.startengine_company_name,
        investmentTypePretty: item?.investment_type_pretty,
        investmentType: item?.investment_type,
        daysLeft: item?.days_left,
        investVerb: item?.invest_verb,
        fundsCommittedPretty: item?.funds_committed_pretty,
        publicFundsCommittedPretty: item?.public_funds_committed_pretty,
        previousRaiseTotalPretty: item?.previous_raise_total_pretty,
        previousRaiseTotal: item?.previous_raise_total,
        last_round_price: item?.last_round_price,
        last_round_valuation: item?.last_round_valuation,
        last_round_date: item?.last_round_date,
        status: item?.status,
      }));
    }
  });

  return transformedCurrentOfferings;
};
